import ReactDOM from 'react-dom/client';
import AppComponent from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './app/store';
import './index.less';
import './global.less';

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);
root.render(<Provider store={store}><AppComponent /></Provider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();